'use client';
import { SectionContainer } from '../component/SectionContainer';
import Tabs, { TabPane } from '../_bs-components/TabCarousel';
import TabTitle from '../_bs-components/TabTitle';
import { VideoReviewItem } from '../type';
import { getCMSIntlVal } from '../utils/common';
import { useLocale } from 'use-intl';
import { useMedia } from '@ssv-website/hooks';
import VideoCardGrid from '../_bs-components/VideoCardGrid';

export default function MeetingVideoReviewSection({
  data,
  title,
}: {
  data: VideoReviewItem[];
  title: string;
}) {
  const defaultKey = data[0].id;
  const locale = useLocale();
  const isMobile = useMedia('mobile');
  return (
    <SectionContainer
      title={<span>{title}</span>}
      titleClassName="mobile:!mb-4"
      contentClassName="mobile:max-w-full mobile:!px-0"
    >
      <Tabs
        activeKey={defaultKey}
        disableDrag={true}
        openSticky={isMobile}
        stickyOffset={60}
        titleClassName="mobile:top-12 bg-[#EDF3FF]"
        titleScrollClassName="mobile:ml-5"
        titleContentClassName="mobile:mr-5"
        paneScrollClassName="mobile:ml-5"
      >
        {data.map((item) => {
          const { videoList } = item;
          const name = getCMSIntlVal(item, 'name', locale);
          const desc = getCMSIntlVal(item, 'desc', locale);
          return (
            <TabPane
              key={item.id}
              tabKey={item.id}
              title={({ isActive }) => {
                return (
                  <TabTitle title={name} subTitle={desc} isActive={isActive} />
                );
              }}
            >
              <VideoCardGrid list={videoList}></VideoCardGrid>
            </TabPane>
          );
        })}
      </Tabs>
    </SectionContainer>
  );
}
